import { render, staticRenderFns } from "./LibraryCategoryAuthorInfo.vue?vue&type=template&id=27022ab5"
import script from "./LibraryCategoryAuthorInfo.vue?vue&type=script&lang=js"
export * from "./LibraryCategoryAuthorInfo.vue?vue&type=script&lang=js"
import style0 from "./LibraryCategoryAuthorInfo.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports